module.exports = __webpack_public_path__ + "3d9fa7f2b3075d153ec1552cd9fe247f.fbx";